import { FC } from "react";
import { Autocomplete, TextField, FormLabel } from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";

export interface AllocationType {
  //TODO CC: this reeplace the old model from the API (//import { AllocationType } from '../../axiosApi/models';)
  name?: string | null;
  id?: number;
}

type AllocationTypeSelectProps = {
  handleAllocationTypeChange: any;
  selectedAllocationType: any;
  allocationTypes: any;
  errors: any;
  disabled: any;
};

const AllocationTypeSelect: FC<AllocationTypeSelectProps> = ({
  handleAllocationTypeChange,
  allocationTypes,
  selectedAllocationType,
  errors,
  disabled,
}) => {
  return (
    <Autocomplete
      id="idAllocationType"
      options={allocationTypes || []}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={
        disabled
          ? allocationTypes?.find((a) => a.id === 1) || null
          : allocationTypes?.find((a) => a.id === selectedAllocationType) || null
      }
      onChange={(event, newValue) => handleAllocationTypeChange(newValue)}
      disabled={disabled}
      loading={allocationTypes == null}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={`${intl.get("employeeProjectForm.allocationType")}`}
          placeholder={intl.get("employeeProjectForm.placeholder.allocation") || "%"}
          error={!!errors.allocationType}
          helperText={errors.allocationType}
          size="small"
        />
      )}
    />
  );
};

export default AllocationTypeSelect;
